<template>
  <v-tour
    ref="myTourRemove"
    name="myTourRemove"
    :steps="steps"
    :options="stepsOptions"
    :callbacks="myCallbacks"
  >
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :step="tour.steps[tour.currentStep]"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :skip="tour.skip"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          :highlight="tour.highlight"
          :class="`step-${tour.currentStep}`"
          :id="'tour-reomove'"
        >
          <template>
            <div slot="content">
              <div class="v-step__content">
                <!-- <div class="dots d-block">
                  <span v-if="tour.currentStep === 0">
                    <v-icon size="8">mdi-checkbox-blank-circle</v-icon>
                    <v-icon size="8">mdi-checkbox-blank-circle-outline</v-icon>
                    <v-icon size="8">mdi-checkbox-blank-circle-outline</v-icon>
                  </span>
                  <span v-if="tour.currentStep === 1">
                    <v-icon size="8">mdi-checkbox-blank-circle-outline</v-icon>
                    <v-icon size="8">mdi-checkbox-blank-circle</v-icon>
                    <v-icon size="8">mdi-checkbox-blank-circle-outline</v-icon>
                  </span>
                  <span v-if="tour.currentStep === 2">
                    <v-icon size="8">mdi-checkbox-blank-circle-outline</v-icon>
                    <v-icon size="8">mdi-checkbox-blank-circle-outline</v-icon>
                    <v-icon size="8">mdi-checkbox-blank-circle</v-icon>
                  </span>
                </div> -->
                <span v-html="tour.steps[tour.currentStep].content"></span>
              </div>
            </div>
            <div slot="actions" class="text-right">
              <button @click="tour.stop" class="btn v-step__button skip">
                X
              </button>
            </div>
            <!-- <span data-v-54f9a632="">
              הזיזו את הכפתור מצד שמאל לימין והסוכן
              <br />
              החכם יכבה ויפסיק לשלוח לכם מיילים.
              <br />  <br />
              שימו לב כי תמיד תוכלו להחזיר את הסוכן
              <br />
              לעבודה ע"י הזזת הכפתור בצורה ההפוכה (מימין לשמאל).
              <br />
              <br />

              שיהיה בהצלחה!
            </span> -->
          </template>
        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
export default {
  props: {
    showTour: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      myCallbacks: {
        onStart: this.onStart,
        onPreviousStep: this.onPreviousStep,
        onNextStep: this.onNextStep,
        onSkip: this.onSkip,
        onFinish: this.onFinish,
      },
      stepsOptions: {
        debug: true,
        startTimeout: 250,
        useKeyboardNavigation: true,
        labels: {
          buttonSkip: 'דלג',
          buttonPrevious: 'הקודם',
          buttonNext: 'הבא',
          buttonStop: 'סיים',
        },
      },
      steps: [
        {
          gtmNumber: 3,
          target: '.switcher-0',
          content: `         <span data-v-54f9a632="">
              הזיזו את הכפתור מצד שמאל לימין והסוכן
              <br />
              החכם יכבה ויפסיק לשלוח לכם מיילים.
              <br />  <br />
              שימו לב כי תמיד תוכלו להחזיר את הסוכן
              <br />
              לעבודה ע"י הזזת הכפתור בצורה ההפוכה
                <br />
               (מימין לשמאל).
              <br />
              <br />

              שיהיה בהצלחה!
            </span>
          
          
          
          `,
          params: {
            placement: 'left',
            enableScrolling: false,
            highlight: true,
          },
        },
      ],
    };
  },
  computed: {},
  methods: {
    onStart() {},
    onPreviousStep() {},
    onNextStep() {},
    onSkip() {},
    onFinish() {
      this.$tours.myTourRemove.stop();
    },
  },
  watch: {
    showTour() {
      this.$tours.myTourRemove.start();
    },
  },
};
</script>
